export class TechBuyer {
  salutationId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  password: string;
  preferredLanguage: string;
  roleCode: string;
  phoneNumber: string;
}

export class TechVendor {
  salutationId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password: string;
  jobTitleId: string;
  lineOfBusinessId: string;
  geographicResponsibilityId: string;
  organizationName: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  countryId: string;
  roleCode: string;
  preferredLanguage: string;
}

export class TechAnalyst {
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  reasonForJoining: string;
  mobileNumber: string;
}

export class NewUser {
  salutationId = "216B941C-07A0-F048-8F38-8072CD8AE793";
  email: string;
  password: string;
  roleCode: string;
}



// WEBPACK FOOTER //
// ./src/app/feature/external/account/shared/models/account.models.ts